import React from "react";

import { Container, Typography } from "@mui/material";
import TestPaymentPageForm from "./view";

const TestPaymentPage = () => {
  return (
    <Container>
      <Typography variant="h3">Test Payment Page</Typography>
      <TestPaymentPageForm />
    </Container>
  );
};

export default TestPaymentPage;
